<template>
    <section class="flex justify-around items-center py-20 sm:h-100 max-w-full overflow-x-hidden">
        <a href="https://www.gruenderzentrum-digitalisierung-niederbayern.de/" rel="noopener" target="_blank" title="GZDN">
            <cdn-image src="/logos/sponsors/gzdn.png" :size="{height: 42 * 0.5, ratio: 3508/954, md: {height: 42}}" :max-width="3508" alt="GZDN"
                 title="Unterstützt durch das Gründerzentrum Digitalisierung Niederbayern" />
        </a>
        <a href="https://www.innkubator.de/" target="_blank" rel="noopener" title="INN.Kubator">
            <cdn-image src="/logos/sponsors/innkubator.png" :size="{height: 48 * 0.5, ratio: 2722/1058, md: {height: 48}}" :max-width="2722" alt="INN.Kubator"
                 title="Unterstützt durch den Inn.Kubator Passau" />
        </a>
        <a href="https://www.exist.de/DE/Home/inhalt.html" target="_blank" rel="noopener" title="EXIST">
            <cdn-image src="/logos/sponsors/exist.png" :size="{height: 60 * 0.5, ratio: 1772/1181, md: {height: 60}}" :max-width="1772" alt="EXIST Logo"
                 title="Ehemals gefördert durch das EXIST-Gründerstipendium" />
        </a>
        <a href="https://www.racesolution.de/" target="_blank" rel="noopener" title="racesolution">
            <cdn-image src="/logos/racesolution/racesolution-logo-full.png" :size="{height: 42 * 0.5, ratio: 1000/311, md: {height: 42}}" :max-width="2822" alt="racesolution"
                              title="Partner von racesolution" />
        </a>
    </section>

</template>